import React from 'react'
import { useNavigate } from 'react-router-dom';
import Button from './Button';
import { MdArrowBack } from 'react-icons/md';
import TranslatableText from '../translations/TranslatableText';
import { TranslationKey } from '../../types/modulesInterfaces';
import { useIconSize } from '@app/hooks';

const BackButton = ({ to, backLabel, style }: { to: string, backLabel: TranslationKey, style?: React.CSSProperties }) => {
  const iconSize = useIconSize(20)
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(to);
  };

  return (
    <Button type="button" className="btn-login ff-medium" onClick={handleClick} style={style}>
      <TranslatableText className="bg-quat-de px-1 label no-wrap" translationKey={backLabel} />
      <div className="bg-quat-br icon">
        <MdArrowBack size={iconSize} color="var(--white)" />
      </div>
    </Button>
  )
}

export default BackButton